const API_URL = import.meta.env.VITE_SUPABASE_URL;
const API_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

const headers = {
  apikey: API_KEY,
  Authorization: `Bearer ${API_KEY}`,
};

export async function publicRows<T>(table: string, query: string): Promise<T[]> {
  const response = await fetch(`${API_URL}/rest/v1/${table}?${query}`, { headers });
  if (!response.ok) throw new Error(`Backend request failed: ${response.status}`);
  return response.json() as Promise<T[]>;
}

export async function publicFunction<T>(name: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`${API_URL}/functions/v1/${name}`, {
    ...init,
    headers: { ...headers, ...(init?.headers ?? {}) },
  });
  if (!response.ok) throw new Error(`Backend function failed: ${response.status}`);
  return response.json() as Promise<T>;
}